exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-wrapper[data-v-63c96f34]{display:flex;flex-direction:column;justify-content:center;align-items:center;margin:30px 300px;padding:20px;background-color:#fff}@media (max-width:800px){.content-wrapper[data-v-63c96f34]{margin:30px 10px;overflow:auto}}.content-wrapper img[data-v-63c96f34]{width:300px;self-align:center}.content-wrapper .image[data-v-63c96f34]{text-align:center}", ""]);

// exports
